import Event from '@oppobrowser/lib-browser-event';
import { getEngine } from '../../js/utils';
import { isTop, browserPartner, isSmallRedBook } from '../../js/constants';
import {
  wordsReport as wRoport,
  newWordsReport as nwReport,
} from '../../js/statH5';
import { v4 as uuidv4 } from 'uuid';
import wv from '@cpc/lib-browser-jsapi';
import './index.scss';
import { getDocId } from '@js/utils-feeds';

const EventHandler = {};

// 版本开关，支持clickSearch方法的客户端版本才需要走客户端方法进行跳转
const versionSwitch = wv.isMethodValid('BrowserIFlow.clickSearch');
// 高亮词挂在到window下面，后续埋点需要使用
window.highLightObj = { highlightSearch: [], highlightSearchType: [] };

export default class Main {
  constructor(el, name, data = {}) {
    this.el = el;
    this._eventHandler = {};
    this.engine = getEngine();

    // 处理图片预览
    this.imagePreviewList = [];
    this.initImagePreview();
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    this.setHeight();
    // 处理正文高量词
    // this.higLightWords();
  }

  initImagePreview() {
    // 如果是小红书的话 就不能再调用 调用多次wv.initArticlePics 会产生冲突
    if (isSmallRedBook) {
      return;
    }

    const regex = /\bhttps?:\/\/[^\s]+\.gif\b/i;

    this.imagePreviewList = window.pageData.DOCINFO.contentPicList.map(
      (item) => {
        return {
          image: item.picUrl || item.url || '',
          isLongImage: false,
          animated: regex.test(item.picUrl || item.url),
          low: item.picUrl || item.url || '',
        };
      },
    ); // 预览图片列表
    wv.initArticlePics(() => this.imagePreviewList);

    const contentDiv = document.querySelectorAll('.content-div');
    contentDiv.forEach((el, index) => {
      el.addEventListener('click', () => {
        this.imageClick(index);
      });
    });
  }

  imageClick(index) {
    if (wv.isMethodValid('BrowserIFlow.switchBigPicMode')) {
      wv.invoke('BrowserIFlow.switchBigPicMode', [
        this.imagePreviewList?.[index]?.image || '',
      ]);
    } else {
      console.error('版本过低不支持方法:　BrowserIFlow.switchBigPicMode');
    }
  }

  // 文章高亮词处理: 客户端配置开关为True&&非置顶文章&&不在极简模式时，才需要展示高亮
  higLightWords() {
    let _this = this;
    let configValue = wv.getConfigValue('CommonConfig_isHighLight')
      ? wv.getConfigValue('CommonConfig_isHighLight').data
      : 0;
    configValue = configValue == 1 ? true : false;
    const isHighLight =
      (configValue && !isTop && window.store.pagemode !== 'simple') || 0;
    if (isHighLight) {
      let nodeList = document.querySelectorAll('.high-light-words');
      for (const [index, ele] of nodeList.entries()) {
        ele.style.color = '#2D40E9';
        ele.index = index;
        ele.addEventListener('click', function (e) {
          const url = this.getAttribute('data-href');
          const type = this.getAttribute('data-type');
          const query = this.textContent;
          const searchId = uuidv4(); //20089004的searchId 和 20089005的 atctionId 需要保持一致，客户端方法clickSearch 会上报20089005埋点
          // 点击上报
          _this.wordsReport({
            position: e.target.index,
            highlightSearch: query,
            highlightSearchType: type,
            highlightUrl: url,
            searchId,
          });

          if (versionSwitch) {
            // 走客户端方法跳转
            _this.goClientWay({ url: url, query: query, actionId: searchId });
          } else {
            // 否则直接跳转url
            window.location.href = url;
          }
        });
      }
      this.exposureWords(Array.from(nodeList)); // 曝光处理
    }
  }

  // 客户端方法跳转
  goClientWay(obj) {
    let params = {
      url: obj.url,
      query: obj.query,
      jumpEngine: this.engine,
      actionId: obj.actionId,
    };
    // 获取客户端配置url，如果存在则替换url
    let configUrl = '';

    if (wv.getConfigValue('CommonConfig_highLightUrl')) {
      let _data = wv.getConfigValue('CommonConfig_highLightUrl').data;
      configUrl = _data == 0 ? '' : _data;
    }

    configUrl
      ? (params.url = configUrl.replace('{searchTerms}', obj.query))
      : '';
    wv.invoke('BrowserIFlow.clickSearch', params);
  }

  // 点击上报
  wordsReport(obj) {
    const sequenceId = uuidv4();
    const { sourceVal } = window.store;
    const params = {
      topCategory: window.pageData.DOCINFO.keywords
        ? window.pageData.DOCINFO.keywords.toString()
        : '',
      secondCategory: window.pageData.DOCINFO.subCategory
        ? window.pageData.DOCINFO.subCategory.toString()
        : '',
      title: window.pageData.DOCINFO.title,
      url: location.href,
      docId: getDocId(),
      source: sourceVal,
      position: obj.position,
      highlightSearch: obj.highlightSearch,
      highlightSearchType: obj.highlightSearchType,
      highlightUrl: obj.highlightUrl,
      sequenceId: sequenceId,
    };
    // 区分端内端外上报
    browserPartner !== 'browser'
      ? wRoport(obj)
      : wv.generalStat('20084486', '10006', '21034', JSON.stringify(params));

    // v8.15新增    产品: 刘多庆(80323734)
    /** 新点击埋点START */
    const openSource = window.BrowserIFlow?.getLaunchMode?.() || '';
    const session = window.BrowserPriv.getSession();
    const appSession = session ? window.btoa(session) : '';

    const newParams = {
      app_session: appSession, // 用户session信息
      searchPage: 'infoDetailPage', //搜索页面
      searchLocation: 'highLightSearch', //搜索具体位置
      sequenceId: sequenceId, // 日志序列号id
      searchId: obj.searchId, // 搜索id
      requestId: uuidv4(),
      openSource: openSource,
      showContent: obj.highlightSearch,

      highlightTitle: window?.pageData?.DOCINFO?.title || document.title || '', // 文章标题 信息流高亮词文章标题
      highlightUrl: window.location.href, // 文章链接 信息流高亮词文章详情页链接
      highlightDocId: window?.pageData?.DOCINFO?.resourceId || '', // 文章id 信息流高亮词文章详情页docId
      highlightSource: window?.store?.sourceVal || '',
      highlightSearchType: obj.highlightSearchType, //高亮词类型 信息流文章高亮词类型详情
      thirdPartyOrigin: false, // 是否三方源
    };
    // 区分端内端外上报
    browserPartner !== 'browser'
      ? nwReport(newParams, '20089004')
      : wv.generalStat('20089004', '10006', '12009', JSON.stringify(newParams));
    /** 新点击埋点END  */
  }

  // 高亮词曝光处理
  exposureWords(nodeList) {
    const options = {
      root: null,
      threshold: 1,
    };
    const openSource = window.BrowserIFlow.getLaunchMode?.() || '';
    const session = window.BrowserPriv.getSession();
    const appSession = session ? window.btoa(session) : '';

    let observer = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item.intersectionRatio === 1) {
          const sequenceId = uuidv4();

          console.log(item.target.textContent, '曝光了');
          window.highLightObj.highlightSearch.push(item.target.textContent);
          window.highLightObj.highlightSearchType.push(
            item.target.getAttribute('data-type'),
          );
          window.highLightObj.sequenceId = sequenceId; // v8.15 新增  日志序列号id
          // 透传数据给到客户端，客户端埋点需要用到
          wv.invoke(
            'BrowserIFlow.syncData',
            JSON.stringify(window.highLightObj),
          );

          // v8.15新增    产品: 刘多庆(80323734)
          /** 新曝光埋点START */
          const data = {
            app_session: appSession, // 用户session信息
            searchPage: 'infoDetailPage', //搜索页面
            searchLocation: 'highLightSearch', //搜索具体位置
            showContent: item.target.textContent, //内容类型,
            sequenceId: sequenceId, // 日志序列号id
            requestId: uuidv4(),
            openSource: openSource,
            highlightTitle:
              window?.pageData?.DOCINFO?.title || document.title || '', // 文章标题 信息流高亮词文章标题
            highlightUrl: window.location.href, // 文章链接 信息流高亮词文章详情页链接
            highlightDocId: window?.pageData?.DOCINFO?.resourceId || '', // 文章id 信息流高亮词文章详情页docId
            highlightSource: window?.store?.sourceVal,
            highlightSearchType: item.target.getAttribute('data-type'), //高亮词类型 信息流文章高亮词类型详情
            thirdPartyOrigin: false, // 是否三方源
          };
          window.wv?.isMethodValid?.('BrowserStat.generalStat')
            ? wv.generalStat('20089003', '10006', '12009', JSON.stringify(data))
            : nwReport(data, '20089003');
          /** 新曝光埋点END */

          observer.unobserve(item.target);
        }
      });
    }, options);
    nodeList.forEach((a) => observer.observe(a));
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  setHeight() {
    let article = document.querySelector('.article');
    let showMore = document.querySelector('.showMore');
    if (window.store.isShowFold && window.store.isShowFold.isShow) {
      article.style['height'] = window.store.isShowFold.heightValue + 'px';
      article.classList.add('fold');
    } else {
      article.style['height'] = 'auto';
      showMore.style['display'] = 'none';
      article.classList.remove('fold');
    }
    // 重新计算视频节点位置 relatedNewsFlow组件的 使用的插件提供的方法
    window.newsFlowRecalcVideoNodePos && window.newsFlowRecalcVideoNodePos();
  }

  render() {}
}
